'use strict';

var toastr = require('toastr');
var DeleteRoleService = function DeleteRoleService(Restangular) {
  function deleteRole(roleName) {
    return Restangular.one('users/roles').customDELETE(roleName).then(function () {
      toastr.success('Role ' + roleName + ' deleted');
    });
  }
  return {
    deleteRole: deleteRole
  };
};
DeleteRoleService.$inject = ['Restangular', 'RsqlQueryFactory'];
module.exports = DeleteRoleService;